import React from 'react'
import { Text } from '../../../../styles/reactnative'

export const column_price = (
	mutate,
	usermodal,
	token,
	fold,
	edit,
	setEdit,
	shareMutate
) => {
	return [
		{
			title: '시간(한국)',
			dataIndex: 'timestamp',
			align: 'center',
			key: 'kdatetime',
			render: (text, record) => {
				return <Text>{new Date(text).toLocaleString('ko-kr')}</Text>
			},
		},
		{
			title: 'UTCTIME',
			dataIndex: 'timestamp',
			align: 'center',
			key: 'odatetime',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '현재가',
			dataIndex: 'o',
			align: 'center',
			key: 'high',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '매도의 저가',
			dataIndex: 'h',
			align: 'center',
			key: 'high',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '매수의 고가',
			dataIndex: 'l',
			align: 'center',
			key: 'low',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},

		{
			title: '매도호가',
			dataIndex: 'short',
			align: 'center',
			key: 'odatetime',
			render: (text, record) => {
				return <Text>{record?.short}</Text>
			},
		},
		{
			title: '매수호가',
			dataIndex: 'long',
			align: 'center',
			key: 'odatetime',
			render: (text, record) => {
				return <Text>{record?.long}</Text>
			},
		},
	]
}
